// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1vHjA","row":"Node_row__2TPCU","label":"Node_label__2XlWd","footer":"Node_footer__1rGDY"};